<template>
  <a-modal
    title="重新设定密码"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    cancelText="关闭"
    style="top:20px;"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <!-- <a-form-item label="用户账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input placeholder="请输入用户账号" v-decorator="[ 'name']" :readOnly="true"/>
        </a-form-item> -->

        <a-form-item label="登陆密码" :labelCol="labelCol" :wrapperCol="wrapperCol" hasFeedback >
          <a-input type="password" placeholder="请输入登陆密码" v-decorator="[ 'password', validatorRules.password]" />
        </a-form-item>

        <a-form-item label="确认密码" :labelCol="labelCol" :wrapperCol="wrapperCol" hasFeedback >
          <a-input type="password" @blur="handleConfirmBlur" placeholder="请重新输入登陆密码" v-decorator="[ 'confirm', validatorRules.confirmpassword]"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { changPassword } from '@/baseAPI/user'

export default {
  name: 'PasswordModal',
  data () {
    return {
      visible: false,
      confirmLoading: false,
      confirmDirty: false,
      validatorRules: {
        password: {
          rules: [{
            required: true, message: '请输入登陆密码!'
          }, {
            validator: this.validateToNextPassword
          }]
        },
        confirmpassword: {
          rules: [{
            required: true, message: '请重新输入登陆密码!'
          }, {
            validator: this.compareToFirstPassword
          }]
        }
      },

      userId: '',

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this)
    }
  },
  created () {
    // console.log("created");
  },

  methods: {
    show (id) {
      this.form.resetFields()
      this.visible = true
      this.userId = id
      // this.model.name = name
      // this.$nextTick(() => {
      //   this.form.setFieldsValue({ name: name })
      // })
    },
    close () {
      this.$emit('close')
      this.visible = false
    },
    handleSubmit () {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          const _this = this
          this.$confirm({
            title: '确认操作',
            content: '是否更新密码?',
            okText: '确认',
            cancelText: '取消',
            onOk: function () {
              _this.confirmLoading = true
              changPassword(_this.userId, values.password).then((res) => {
                _this.$notification.success({
                  message: '提示',
                  description: res.message || '更新密码成功',
                  duration: 3
                })
              }).catch(err => {
                _this.$notification.error({
                  message: '错误',
                  description: ((err.response || {}).data || {}).message || '更新密码失败',
                  duration: 3
                })
              }).finally(() => {
                _this.confirmLoading = false
                _this.close()
              })
            }
          })
        }
      })
    },
    handleCancel () {
      this.close()
    },
    validateToNextPassword  (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true })
      }
      callback()
    },
    // validateSimpePassword (rule, value, callback) {
    //   const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,16}$/;
    //   if (value && !pattern.test(value)) {
    //     callback(new Error('密码长度8-16，必须包含大写字母、小写字母、数字、特殊字符:!@#$%^&*()'))
    //   } else {
    //     callback()
    //   }
    // },
    compareToFirstPassword  (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    },
    handleConfirmBlur  (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    }

  }
}
</script>
